import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { activitiesApi } from "@/lib/humhub-api/activities";

export const useActivities = (
  containerId?: string | number,
  initialPage = 1,
  initialPerPage = 20,
) => {
  const [page, setPage] = useState<number>(initialPage);
  const [perPage, setPerPage] = useState<number>(initialPerPage);

  // Enable the query only if containerId is provided
  const enabled = !!containerId;

  // React Queryでデータ取得
  const {
    data: activities,
    isLoading: loading,
    error: queryError,
    refetch: queryRefetch,
  } = useQuery({
    queryKey: ["activities", { containerId, page, perPage }],
    queryFn: () => {
      if (!containerId) {
        throw new Error("Container ID is required to fetch activities");
      }
      return activitiesApi.getActivities(containerId, page, perPage);
    },
    staleTime: 5 * 60 * 1000, // 5分間キャッシュ
    enabled,
  });

  const handlePageChange = useCallback((newPage: number) => {
    setPage(newPage);
  }, []);

  const handlePerPageChange = useCallback((newPerPage: number) => {
    setPerPage(newPerPage);
    setPage(1);
  }, []);

  const refetch = useCallback(() => {
    return queryRefetch();
  }, [queryRefetch]);

  return {
    data: activities?.results || [],
    pagination: activities
      ? {
          total: activities.total,
          page,
          perPage,
          pages: activities.pages,
          links: activities.links,
        }
      : undefined,
    isLoading: loading,
    error: queryError ? String(queryError) : null,
    handlePageChange,
    handlePerPageChange,
    refetch,
  };
};
